import { firebaseProjectTarget } from './firebase/config';

const productionConfig = {
    GOOGLE_MAPS_API_KEY: 'AIzaSyDrGtQdTHCh1zQTt6OUgibrhVLS7NvV0Vc',
    STRIPE_STANDARD_MONTHLY_PRICE_ID: 'price_1QchBEAZjGEVNC9fP1XxnEIt',
    STRIPE_STANDARD_YEARLY_PRICE_ID: 'price_1QchBEAZjGEVNC9fbzbNwZv3',
    STRIPE_PRO_MONTHLY_PRICE_ID: 'price_1QchLcAZjGEVNC9fiQzY0Jjd',
    STRIPE_PRO_YEARLY_PRICE_ID: 'price_1QchLcAZjGEVNC9fsMtYkkdq',
    STRIPE_PUBLIC_KEY: 'pk_live_0wdXjv3PiDO45Lhu3zzNLJqz',
    STRIPE_CLOUD_FUNCTION_BASE_URL: 'https://northamerica-northeast1-facesearchme.cloudfunctions.net/courtclic-stripe-prod'
};

const stagingConfig = {
    GOOGLE_MAPS_API_KEY: 'AIzaSyDzkBE1kcL5j52p6ea3k3DtW_W4eMyT4T4',
    STRIPE_STANDARD_MONTHLY_PRICE_ID: 'price_1QchFHAZjGEVNC9f3TgZCoTT',
    STRIPE_STANDARD_YEARLY_PRICE_ID: 'price_1QchDzAZjGEVNC9feQlLP47h',
    STRIPE_PRO_MONTHLY_PRICE_ID: 'price_1P0000000000000000000000',
    STRIPE_PRO_YEARLY_PRICE_ID: 'price_1P0000000000000000000000',
    STRIPE_PUBLIC_KEY: 'pk_test_QFrLo7zz3jj9tSwT2FrDmvxn',
    STRIPE_CLOUD_FUNCTION_BASE_URL: 'https://northamerica-northeast1-facesearchme.cloudfunctions.net/courtClic-stripe'
};

export const getRuntimeConfigForTarget = (target = '') =>
    ['production', 'prod', 'main'].includes(target.toLowerCase())
        ? productionConfig
        : stagingConfig;

const runtimeConfig = getRuntimeConfigForTarget(firebaseProjectTarget);

export const GOOGLE_MAPS_API_KEY_PROD = productionConfig.GOOGLE_MAPS_API_KEY;
export const GOOGLE_MAPS_API_KEY = runtimeConfig.GOOGLE_MAPS_API_KEY;
export const STRIPE_STANDARD_MONTHLY_PRICE_ID = runtimeConfig.STRIPE_STANDARD_MONTHLY_PRICE_ID;
export const STRIPE_STANDARD_YEARLY_PRICE_ID = runtimeConfig.STRIPE_STANDARD_YEARLY_PRICE_ID;
export const STRIPE_PRO_MONTHLY_PRICE_ID = runtimeConfig.STRIPE_PRO_MONTHLY_PRICE_ID;
export const STRIPE_PRO_YEARLY_PRICE_ID = runtimeConfig.STRIPE_PRO_YEARLY_PRICE_ID;
export const STRIPE_PUBLIC_KEY = runtimeConfig.STRIPE_PUBLIC_KEY;
export const STRIPE_CLOUD_FUNCTION_BASE_URL = runtimeConfig.STRIPE_CLOUD_FUNCTION_BASE_URL;
